import { Fiskaly } from "@data-types";
import { getDisplayedAmount } from "@utils";

import { DateTime } from "luxon";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

export default observer(function FiskalySection(props: {
	metadata: Fiskaly;
	currency?: string;
}) {
	const { t } = useTranslation("mybets");

	const metaData: Fiskaly = props.metadata;
	if (metaData.fiskalyReceiptNumber == null) {
		metaData.hints = ["Sicherheitseinrichtung ausgefallen"];
	}

	return (
		<>
			{metaData.timeSignature && (
				<tr className="table--bets__tr table--bets__fiscalization table--bets__fiscalization--dashed">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("ITEM.FISKALY_DATE")}:
						</span>
						<span>
							{DateTime.fromISO(
								metaData.timeSignature + "Z"
							).toLocaleString(DateTime.DATETIME_SHORT)}
						</span>
					</td>
				</tr>
			)}
			{metaData.fiskalyReceiptNumber && (
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("ITEM.FISKALY_RECIPET_NUMBER")}:
						</span>
						<span>{metaData.fiskalyReceiptNumber}</span>
					</td>
				</tr>
			)}
			{metaData.fiskalyCashRegisterSerialNumber && (
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("ITEM.FISKALY_SERIAL_NUMBER")}:
						</span>
						<span>{metaData.fiskalyCashRegisterSerialNumber}</span>
					</td>
				</tr>
			)}

			{metaData.grossAmountZero && (
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("ITEM.GROSS_AMOUNT_STANDARD")}:
						</span>
						<span>
							{getDisplayedAmount(
								+metaData.grossAmountZero,
								props.currency
							)}
						</span>
					</td>
				</tr>
			)}

			{metaData.hints && metaData.hints.length > 0 && (
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("ITEM.HINTS")}:
						</span>
						<span>{metaData.hints[0]}</span>
					</td>
				</tr>
			)}
		</>
	);
});
